var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCat201(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cat_201"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_201",
    "data-name": 201,
    className: "cls-2",
    d: "M21.1,11.09C31.63-.71,57-.81,69.25,11.3,79.07,21,77.37,35.35,76,47.08,73.49,68,61.69,98.55,47.23,98.8c-16,.28-27.73-36.75-30.37-59.12C15.53,28.43,14.51,18.48,21.1,11.09Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat201);
export default __webpack_public_path__ + "static/media/cat_201.785cd88f1ef29449d70727e8de035303.svg";
export { ForwardRef as ReactComponent };